"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpointValue, Menu as ChakraMenu } from "@chakra-ui/react";
const DropdownMenu = (props) => {
    const gutter = useBreakpointValue({ base: 4, md: 0 });
    return _jsx(ChakraMenu, Object.assign({ gutter: gutter }, props));
};
DropdownMenu.displayName = "DropdownMenu";
export default DropdownMenu;
//# sourceMappingURL=DropdownMenu.js.map